import React from 'react';
import ClientContext from '../../../contexts/ClientContext'
import StatusContext from '../../../contexts/StatusContext'
import Credits from '../credits/Credits';
import {PushButton} from '../pushbutton/PushButton'


import "./availablecredits.css"

export const AvailableCredits = ({label, onClick}) => {
  let {
    changeLanguage,
    setShowCreditsDialog,
} = React.useContext(StatusContext);

  let {
    availablecredits,
} = React.useContext(ClientContext);

const handleCredits = () =>{
  console.log("handleCredits")
  setShowCreditsDialog(true)
}

  
  return (
       
      <div className="creditsLabel">
       
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <PushButton
            onClick={handleCredits}
            label={changeLanguage('tutor', 'credits')}
            colorback="green"
          />
          : {availablecredits.toLocaleString()}
        </div>


         <Credits />
     
      </div> 
     
  );
};

AvailableCredits.defaultProps = {
 
}
